/**
 * Created by User on 29-Jul-17.
 */
import React,{Component} from 'react';

import {FormGroup,ControlLabel} from 'react-bootstrap';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

class SelectWrap extends Component {
    constructor(props) {
        super(props);

        this.handleOnChange = this.handleOnChange.bind(this);
        this.handlePaste = this.handlePaste.bind(this);
    }

    handleOnChange(data) {
        if(this.props.onChange) {
            let value;

            if(!data) value = null;
            else if(Array.isArray(data)) value = data.map(item => item.value);
            else value = data.value;

            const event = {
                target: {
                    value: value,
                    name: this.props.name
                }
            }
            this.props.onChange(event);
        }
    }

    handlePaste(event) {
        event.preventDefault();

        let baseValues = [];

        if(this.props.value) baseValues = this.props.value.map(country => ({ value: country }));

        const values = event.clipboardData.getData('text').split(',')
            .reduce((arr, value) => {
                let valueExist;

                if(Array.isArray(this.props.values)) valueExist = this.props.values.findIndex(item => item == value) !== -1;
                else valueExist = this.props.values[value];

                if(valueExist) arr.push(({ value: value }));

                return arr;
            }, []);

        this.handleOnChange([ ...baseValues, ...values ]);
    }

    render() {
        const {values} = this.props;

        let options;

        if(values) {
            options = Array.isArray(values) ? arrToOptions(values) : objToOptions(values);
        }
        else {
            options = [];
        }

        const label = this.props.label ? <ControlLabel>{this.props.label}</ControlLabel> : null;

        return (
            <FormGroup>
                {label}
                <div onPaste={this.handlePaste}>
                    <Select
                        style={this.props.style || {}}
                        options={options}
                        placeholder={this.props.placeholder || ""}
                        value={this.props.value}
                        multi={this.props.multi}
                        disabled={this.props.disabled}
                        onChange={this.handleOnChange}
                        required={this.props.required}
                    />
                </div>
            </FormGroup>
        );
    }
}

function objToOptions(obj) {
    return Object.keys(obj).map(value => {
        const label = obj[value];

        return {label,value: value.toString() };
    })
}

function arrToOptions(arr) {
    return arr.map(item => {
        return {
            value: item.toString(),
            label: item
        };
    })
}

export default SelectWrap;



// WEBPACK FOOTER //
// ./src/components/SelectWrap/index.js